import React, { useState } from "react";

import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import TableTemplate from "@components/Table/TableTemplate";
import { PREREGISTRATION_SCHOOL_ENDPOINT } from "@constants/Endpoints";
import PreRegSchoolStatusEnum from "@constants/PreRegistrationState";

import "./PreregistrationSchools.scss";

/**
 * SchoolManagementView component renders a table displaying school data.
 *
 * @param {Object} props - The component props.
 * @param {React.MutableRefObject} props.tableTemplateRef
 * @param {Object} props.activeSchool
 */

export function PreregistrationSchoolsView(props) {
    const [t] = useTranslation();
    const [columns] = useState([
        {
            name: "name",
            headerCaption: t("Name"),
            size: "normal-x",
            canSort: true,
            filterName: "schoolName",
            canFilter: true,
            canEdit: false,
        },
        {
            name: "schoolNumber",
            headerCaption: t("SchoolNumber"),
            size: "normal-x",
            canSort: true,
            canFilter: true,
            canEdit: false,
        },
        {
            name: "schoolDeliveryType",
            headerCaption: t("SchoolDeliveryType"),
            filterName: "schoolType",
            size: "normal-x",
            canSort: true,
            canFilter: true,
            canEdit: false,
        },
        {
            name: "preRegistrationStatus",
            headerCaption: t("PreRegistrationStatus"),
            filterName: "preRegStatus",
            size: "normal-x",
            caption: (x) => t(PreRegSchoolStatusEnum[x.preRegistrationStatus]) || t("Unknown"),
            canSort: true,
            canFilter: true,
            canEdit: false,
        },
        {
            name: "totalBooks",
            headerCaption: t("TotalBooks"),
            size: "normal-x",
            canSort: true,
            canFilter: false,
            canEdit: false,
        },
        {
            name: "booksToBeReturned",
            headerCaption: t("BooksToBeReturned"),
            size: "normal-x",
            canSort: true,
            canFilter: false,
            canEdit: false,
        },
        {
            name: "booksNotToBeReturned",
            headerCaption: t("BooksNotToBeReturned"),
            size: "normal-x",
            canSort: true,
            canFilter: false,
            canEdit: false,
        },
        {
            name: "booksToTakeOver",
            headerCaption: t("BooksToTakeOver"),
            size: "normal-x",
            canSort: true,
            canFilter: false,
            canEdit: false,
        },
        {
            name: "booksNotToTakeOver",
            headerCaption: t("BooksNotToTakeOver"),
            size: "normal-x",
            canSort: true,
            canFilter: false,
            canEdit: false,
        },
        {
            name: "schoolActiveNextYear",
            headerCaption: t("IsExitSchool"),
            textAlign: "center",
            size: "small",
            caption: (/** @type {School} */ x) => <input type="checkbox" checked={!x.schoolActiveNextYear} readOnly />,
            canSort: false,
            canFilter: false,
            canEdit: false,
        },
    ]);

    return (
        <div className="school-management-page">
            <TableTemplate
                ref={props.tableTemplateRef}
                // @ts-ignore
                title={t("Schools")}
                endpoint={PREREGISTRATION_SCHOOL_ENDPOINT}
                columns={columns}
                uniqueId="id"
                paginator={true}
            />
        </div>
    );
}

export default PreregistrationSchoolsView;
